import { STORE_CONFLICTS, IS_FETCHING } from '../actions/downgradeConflicts';

const conflicts = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === STORE_CONFLICTS) {
        const {
            pagination,
            downgradeConflicts,
            organizationId,
            desiredPackage,
        } = payload;
        const { pageNumber } = pagination;
        nextState = {
            ...state,
            pagination,
            downgradeConflicts: {
                ...state.downgradeConflicts,
                [pageNumber]: downgradeConflicts,
            },
            organizationId,
            desiredPackage,
        };
    }

    return nextState;
};

const fetchingConflicts = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === IS_FETCHING) {
        nextState = payload;
    }

    return nextState;
};

export default { conflicts, fetchingConflicts };
